import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export const InvoiceListCreatedAtHeader = (): ReactNode => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return t('delmonicos-shared-sdk.outputs-base-with-timestamp.created-at');
};
